/** @jsxImportSource @emotion/react */
import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import UtComparisonElecPage from './UtComparisonElecPage';
import { useUtComparisonElecStore } from './store/useUtComparisonElecStore';
import { elecRptDetailToDiffRows, errorMessage } from './api';
import { getReportDetail } from 'apis/ut/UtMatrixComparisonReportList';

interface Props {
  rptId?: string;
}

const UtComparisonElecReportPage = ({ rptId }: Props = {}) => {
  const location = useLocation();
  const loadHistorySnapshot = useUtComparisonElecStore((s) => s.loadHistorySnapshot);
  const reset = useUtComparisonElecStore((s) => s.reset);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  // 마지막으로 로드한 rptId (props로 rptId가 바뀌면 다시 로드)
  const loadedRef = useRef<string | null>(null);

  useEffect(() => {
    if (!rptId || loadedRef.current === rptId) return;
    loadedRef.current = rptId;
    setLoading(true);
    setError(null);
    // 통합 상세 API — 저장된 스냅샷(RPT_ELPW_D)을 그대로 복원한다(재분석하지 않음)
    getReportDetail(rptId)
      .then((detail) => {
        // elecRptDetailToDiffRows는 details 키를 읽으므로 전기 상세를 그 자리에 맞춰 넘긴다
        const elecDetail: any = {
          ...detail,
          details: detail?.elecDetails ?? detail?.details ?? [],
        };
        loadHistorySnapshot({
          diffRows: elecRptDetailToDiffRows(elecDetail),
          analyzedMatrices: detail?.targets || [],
          historyRptId: rptId,
        });
      })
      .catch((e) => {
        setError(errorMessage(e));
      })
      .finally(() => {
        setLoading(false);
      });
  }, [rptId]);

  useEffect(() => {
    return () => reset();
  }, []);

  if (loading) {
    return (
      <div style={{ padding: 24, textAlign: 'center', color: '#2d9bb2', fontSize: 12 }}>
        이력을 불러오는 중...
      </div>
    );
  }
  if (error) {
    return (
      <div
        style={{
          margin: 16,
          border: '1px solid #fda293',
          background: '#fef1eb',
          color: '#b32542',
          borderRadius: 3,
          padding: '10px 14px',
          fontSize: 12,
        }}
      >
        이력 조회 오류: {error}
      </div>
    );
  }
  return <UtComparisonElecPage />;
};
export default UtComparisonElecReportPage;
